import { tableHelper, fieldHelper } from '@builttocreate/engine-utils';
import FieldTypes from './FieldTypes';

import FieldDisplayTypes from './FieldDisplayTypes';
import FormStylesOptions from './FormStylesOptions';

import ThemeIcons from '../theme/Icons';

const { getDefaultOption } = fieldHelper;
const { getDefaultRow, getDefaultTextColumn, getDefaultDropdownColumn } = tableHelper;

export default [
  /*
   * Uncomment below to use richText fields on form
   * {
    title: 'Rich',
    type: FieldTypes.richText,
    icon: ThemeIcons.fields.richText,
    displayType: FieldDisplayTypes.original,
    description: 'Logo or graphic'
  },*/
  {
    title: 'Image',
    type: FieldTypes.image,
    icon: ThemeIcons.fields.image,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'File',
    type: FieldTypes.file,
    icon: ThemeIcons.fields.file,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'Heading Text',
    type: FieldTypes.block,
    icon: ThemeIcons.fields.blockHeading,
    displayType: FieldDisplayTypes.original,
    value: 'Heading',
    fontSize: 28,
    fontWeight: FormStylesOptions.fontWeightBold,
  },
  {
    title: 'Display Text',
    type: FieldTypes.block,
    icon: ThemeIcons.fields.blockParagraph,
    displayType: FieldDisplayTypes.original,
    value: 'Display text',
  },
  {
    title: 'Empty Space',
    type: FieldTypes.block,
    icon: ThemeIcons.fields.blockEmptyspace,
    displayType: FieldDisplayTypes.original,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
  },
  {
    title: 'Text',
    type: FieldTypes.text,
    icon: ThemeIcons.fields.text,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'Multiline Text',
    type: FieldTypes.textarea,
    icon: ThemeIcons.fields.textarea,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'Number',
    type: FieldTypes.number,
    icon: ThemeIcons.fields.number,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'Date Time',
    type: FieldTypes.date,
    icon: ThemeIcons.fields.date,
    displayType: FieldDisplayTypes.original,
    format: 'MM/DD/YYYY hh:mma'
  },
  {
    title: 'Dropdown',
    type: FieldTypes.dropdown,
    icon: ThemeIcons.fields.dropdown,
    displayType: FieldDisplayTypes.original,
    options: [getDefaultOption('Yes'), getDefaultOption('No'), getDefaultOption('N/A')],
  },
  {
    title: 'Multiple Choice',
    type: FieldTypes.multiSelect,
    icon: ThemeIcons.fields.multiSelect,
    multi: true,
    displayType: FieldDisplayTypes.original,
    options: [getDefaultOption('Yes'), getDefaultOption('No'), getDefaultOption('N/A')],
  },
  {
    title: 'Single Choice',
    type: FieldTypes.multiSelect,
    icon: ThemeIcons.fields.multiSelectSingle,
    multi: false,
    displayType: FieldDisplayTypes.original,
    options: [getDefaultOption('Yes'), getDefaultOption('No'), getDefaultOption('N/A')],
  },
  {
    title: 'Checkbox',
    type: FieldTypes.multiSelect,
    icon: ThemeIcons.fields.selector,
    displayType: FieldDisplayTypes.check,
    options: [getDefaultOption('Option 1')],
  },
  {
    title: 'Signature',
    type: FieldTypes.signature,
    icon: ThemeIcons.fields.signature,
    displayType: FieldDisplayTypes.original,
  },
  {
    title: 'Table',
    type: FieldTypes.table,
    icon: ThemeIcons.fields.table,
    displayType: FieldDisplayTypes.original,
    tableColumns: [
      getDefaultTextColumn({ width: 0 }), //0 or undefined indicates auto width (responsive)
      getDefaultDropdownColumn({ width: 0 }), //0 or undefined indicates auto width (responsive)
      getDefaultTextColumn({ width: 0 }), //0 or undefined indicates auto width (responsive)
    ],
    value: [getDefaultRow(), getDefaultRow(), getDefaultRow()],
  },
  {
    title: 'Chart',
    type: FieldTypes.chart,
    icon: ThemeIcons.fields.chart,
    displayType: FieldDisplayTypes.original,
    primaryDisplayOnly: true,
    yTitle: 'Vertical',
    yMax: 100,
    yMin: 0,
    xTitle: 'Horizontal',
    xMax: 100,
    xMin: 0,
  }
];
